import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

import { TextField } from '../../../TextField/TextField.tsx';

import { TEXT_FIELD_HEIGHT } from './constants.ts';

export const StyledActionButtonsStack = styled(Stack, {
  shouldForwardProp: prop => prop !== 'hasMarginTop',
})<{ hasMarginTop?: boolean }>`
  align-items: center;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing(1)};
  height: ${({ theme }) => theme.spacing(5)};
  margin-top: ${({ hasMarginTop, theme }) => (hasMarginTop ? theme.spacing(1) : 0)};
`;

export const StyledContainerStack = styled(Stack, {
  shouldForwardProp: prop => prop !== 'height',
})<{ height: number }>`
  background: ${({ theme }) => theme.palette.background.boxLight};
  bottom: 0;
  height: ${({ height }) => height}px;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing(1.5)};
  position: absolute;
  width: 100%;
  z-index: 1;
`;

export const StyledFooterButtonStack = styled(Stack)`
  align-items: center;
  background: ${({ theme }) => theme.palette.background.paper};
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing(1)};
  height: ${({ theme }) => theme.spacing(5)};
  padding-inline: ${({ theme }) => theme.spacing(1)};
`;

export const StyledInputStack = styled(Stack)`
  display: flex;
  flex-grow: 1;
  overflow-y: scroll;
`;

export const StyledTextField = styled(TextField)`
  .MuiInput-root {
    height: 100%;
  }

  .MuiInput-root > textarea:first-of-type {
    height: 100% !important;
  }

  flex-grow: 1;
  margin-block: ${({ theme }) => theme.spacing(1)};
  min-height: ${TEXT_FIELD_HEIGHT}px;
`;
